import React, { memo } from 'react';
import { OUT_OF_HOURS_TITLE, outOfHoursTime } from './outOfHours';

// Faixa "Fora do horário" na Lista do dia: um <li> só de texto (não abre nada), hachurado como no Dia e na Semana do
// calendário. O leitor de tela ouve "12:00 até 13:30, Fora do horário, BRUNO e PAULA"
const OutOfHoursRow = ({ row, doctorNames }) => {
  const time = outOfHoursTime(row);

  return (
    <li className='agenda-day-off'>
      <span className='agenda-day-off-time'>
        {time.text ?? <>{time.start}<span aria-hidden='true'>–</span><span className='visually-hidden'> até </span>{time.end}</>}
      </span>
      <span className='agenda-day-off-text'>
        <span className='visually-hidden'>, </span>{OUT_OF_HOURS_TITLE}
        <span aria-hidden='true'> · </span><span className='visually-hidden'>, </span>{doctorNames}
      </span>
    </li>
  );
};

export default memo(OutOfHoursRow);
